export const environmentState = (state = {}, action) => {
  if (action.type === 'UPDATE_ENVIRONMENT') {
    const newState = { ...state, ...action.environmentState };

    return newState;
  }

  return state;
};
